// extracted by mini-css-extract-plugin
module.exports = {"button":"SkjemadetaljerButton_button__q_NPP"};